// extracted by mini-css-extract-plugin
export default {"routes_desktop":"RouteList_routes_desktop__bOHxZ","routes_header":"RouteList_routes_header__E-Fbn","title":"RouteList_title__4X9KU","route_list":"RouteList_route_list__oY3jt"};